<script>
  import ServicesPage from '$lib/pages/ServicesPage.svelte';
</script>

<ServicesPage />

